import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

interface Props {
  children: JSX.Element
}

export const ErrorRoute = ({ children }: Props) => {
  const navigate = useNavigate()

  useEffect(() => {
    const onRefresh = (event: any) => {
      event.preventDefault();
      navigate('/', { replace: true })
    }

    window.addEventListener('beforeunload', onRefresh)

    return () => {
      window.removeEventListener('beforeunload', onRefresh)
    }
  }, [])

  return children
}
